var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 362 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.3141 0.303 60.5589921 0.303 60.5589921 65.4617545 0.3141 65.4617545"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 83.6973 361.314 83.6973 361.314 1.0003 0 1.0003"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7944,38.9863 C60.7874,41.4203 32.9114,59.6753 15.8484,83.3653 C10.7414,82.4113 4.7834,82.4523 0.0004,83.6423 C21.2944,53.8943 57.5684,35.2253 80.7744,38.6273 C80.9254,38.6553 81.0524,38.6783 81.0524,38.7953 C81.0524,38.9103 81.0064,38.9583 80.7944,38.9863",
    id: "Fill-1",
    fill: "#DE0050"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(146.000000, 0.697300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2031,0.7255 C65.2031,18.3915 59.2771,34.9235 47.3651,46.8045 C29.9031,64.2235 8.1201,66.2875 0.6381,65.2365 C0.3621,65.2015 0.3141,65.1575 0.3141,65.0525 C0.3141,64.9465 0.4531,64.8755 0.6291,64.8435 C28.5111,59.5935 52.8561,34.6805 55.5621,0.7475 C55.5741,0.4985 55.6341,0.3025 55.7821,0.3025 C55.9341,0.3025 56.1071,0.4985 56.2031,0.7255",
    id: "Fill-3",
    fill: "#46B035",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.6104,65.7607 C140.5334,65.8767 139.4644,65.9587 138.4224,65.9977 C124.0514,66.5477 116.2224,59.7817 107.9374,52.6167 C101.7054,47.2257 94.2874,40.6147 85.6624,39.0887 C85.4184,39.0637 85.2684,39.0517 85.2684,38.8757 C85.2684,38.7357 85.4434,38.7137 85.6164,38.6857 C90.0264,38.0737 94.5644,38.3437 98.4874,39.0217 C109.7054,40.9567 116.7724,47.0917 123.6064,53.0287 C129.1334,57.8287 134.9164,63.5407 141.6304,65.3247 C141.8414,65.3747 141.9734,65.4097 141.9734,65.5627 C141.9734,65.7147 141.8414,65.7367 141.6104,65.7607",
    id: "Fill-6",
    fill: "#F9BE00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#0C318F",
    points: "306.0723 42.623 306.0723 38.436 272.2563 38.436 272.2563 42.623 284.6293 42.623 284.6293 69.131 293.7073 69.131 293.6993 42.623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.7168,54.7207 L323.8278,43.2277 L326.9338,43.2277 L332.2308,54.7207 L318.7168,54.7207 Z M335.6268,41.5177 C334.4058,39.2677 333.0628,38.4357 330.4158,38.4357 L320.7008,38.4357 L305.7288,69.1307 L312.3008,69.1307 L316.8558,58.9067 L334.1548,58.9067 L337.3888,65.9327 C338.5778,68.2637 340.1308,69.1307 343.2658,69.1307 L349.0998,69.1307 L335.6268,41.5177 Z",
    id: "Fill-10",
    fill: "#0C318F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2969,64.0586 L259.0609,64.0586 L245.1309,42.1766 C243.1409,39.0346 240.9469,38.4356 237.1779,38.4356 L230.0289,38.4356 L230.0289,69.1306 L235.4809,69.1306 L235.4809,43.4966 L235.6899,43.5016 L249.6169,65.3816 C251.6099,68.5236 253.7889,69.1306 257.5699,69.1306 L264.7499,69.1306 L264.7499,38.4356 L259.2969,38.4356 L259.2969,64.0586 Z",
    id: "Fill-12",
    fill: "#0C318F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#0C318F",
    points: "217.8438 76.3564 219.2478 76.3564 222.4298 82.1724 222.4538 82.1724 222.4538 76.3564 223.4808 76.3564 223.4808 83.5744 222.1598 83.5744 218.8968 77.6194 218.8768 77.6194 218.8768 83.5744 217.8438 83.5744"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "226.844 83.5743 227.895 83.5743 227.895 76.3563 226.844 76.3563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2637,83.5742 L232.3007,83.5742 L232.3007,80.6902 L233.3317,80.6902 C234.6207,80.6902 235.8867,80.1012 235.8867,78.5102 C235.8867,76.8772 234.6387,76.3562 233.1777,76.3562 L231.2637,76.3562 L231.2637,83.5742 Z M232.3007,77.2632 L233.1957,77.2632 C233.8207,77.2632 234.7697,77.5812 234.7697,78.4992 C234.7697,79.4412 233.9667,79.7662 233.3477,79.7662 L232.3007,79.7662 L232.3007,77.2632 Z",
    id: "Fill-18",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1719,83.5742 L239.2089,83.5742 L239.2089,80.6902 L240.2229,80.6902 C241.5269,80.6902 242.7759,80.1012 242.7759,78.5102 C242.7759,76.8772 241.5489,76.3562 240.0719,76.3562 L238.1719,76.3562 L238.1719,83.5742 Z M239.2089,77.2632 L240.0919,77.2632 C240.7249,77.2632 241.6799,77.5812 241.6799,78.4992 C241.6799,79.4412 240.8749,79.7662 240.2349,79.7662 L239.2089,79.7662 L239.2089,77.2632 Z",
    id: "Fill-19",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.7207,79.9531 C244.7207,82.1621 246.0137,83.6971 248.2127,83.6971 C250.4277,83.6971 251.6877,82.1621 251.6877,79.9531 C251.6877,77.8191 250.4137,76.2361 248.2127,76.2361 C246.0197,76.2361 244.7207,77.8191 244.7207,79.9531 M245.8397,79.9531 C245.8397,78.4901 246.6207,77.1101 248.2127,77.1241 C249.8047,77.1101 250.5977,78.4901 250.5977,79.9531 C250.5977,81.4141 249.8787,82.7851 248.2127,82.7851 C246.5507,82.7851 245.8397,81.4141 245.8397,79.9531",
    id: "Fill-20",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "254.5664 76.3564 255.9904 76.3564 259.1774 82.1724 259.1954 82.1724 259.1954 76.3564 260.2344 76.3564 260.2344 83.5744 258.9004 83.5744 255.6384 77.6194 255.6214 77.6194 255.6214 83.5744 254.5664 83.5744"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "268.1738 77.2636 265.9278 77.2636 265.9278 76.3566 271.4528 76.3566 271.4528 77.2636 269.2068 77.2636 269.2068 83.5746 268.1738 83.5746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.8848,83.5742 L274.9058,83.5742 L274.9058,80.3872 L275.5328,80.3872 C276.0958,80.3872 276.4358,80.3872 276.7558,81.0742 L277.8458,83.5742 L279.0428,83.5742 L277.6618,80.7032 C277.4398,80.2712 277.2908,80.0822 276.9768,79.9622 L276.9768,79.9422 C277.7928,79.7992 278.4588,79.1732 278.4588,78.3092 C278.4588,76.5762 277.0858,76.3562 275.6598,76.3562 L273.8848,76.3562 L273.8848,83.5742 Z M274.9058,77.2632 L275.9178,77.2632 C276.8728,77.2632 277.3618,77.6782 277.3618,78.3252 C277.3618,79.0032 276.7888,79.4412 275.8088,79.4412 L274.9058,79.4412 L274.9058,77.2632 Z",
    id: "Fill-23",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7754,83.5742 L281.8694,83.5742 L282.5974,81.7592 L286.1504,81.7592 L286.8884,83.5742 L287.9964,83.5742 L284.9434,76.3562 L283.8794,76.3562 L280.7754,83.5742 Z M285.8204,80.9172 L282.9334,80.9172 L284.3714,77.3202 L285.8204,80.9172 Z",
    id: "Fill-24",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "293.0586 83.5742 291.7616 83.5742 289.0586 76.3562 290.2186 76.3562 292.4256 82.6612 292.4476 82.6612 294.7756 76.3562 295.8616 76.3562"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "298.168 76.3564 302.193 76.3564 302.193 77.2634 299.197 77.2634 299.197 79.3634 301.928 79.3634 301.928 80.3044 299.197 80.3044 299.197 82.6614 302.193 82.6614 302.193 83.5744 298.168 83.5744"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "305.2441 76.3564 306.2831 76.3564 306.2831 82.6614 309.2871 82.6614 309.2871 83.5744 305.2441 83.5744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2539,83.5742 L315.3999,83.5742 L316.1289,81.7592 L319.6539,81.7592 L320.3869,83.5742 L321.5039,83.5742 L318.4609,76.3562 L317.3889,76.3562 L314.2539,83.5742 Z M319.3239,80.9172 L316.4629,80.9172 L317.8849,77.3202 L319.3239,80.9172 Z",
    id: "Fill-28",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.9648,77.6191 C328.4588,77.3011 327.9098,77.1241 326.9938,77.1241 C325.3318,77.1241 324.1758,78.3481 324.1758,79.9531 C324.1758,81.6611 325.4488,82.7851 326.9488,82.7851 C327.6488,82.7851 327.8318,82.7121 328.0838,82.6611 L328.0838,80.4851 L326.5878,80.4851 L326.5878,79.6061 L329.1248,79.6061 L329.1248,83.3791 C328.7328,83.5151 328.0448,83.6971 326.9338,83.6971 C324.6128,83.6971 323.0858,82.2381 323.0858,79.9231 C323.0858,77.7131 324.7088,76.2361 326.9488,76.2361 C327.9828,76.2361 328.4508,76.3871 329.0508,76.5851 L328.9648,77.6191 Z",
    id: "Fill-29",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "332.5449 76.3564 336.6309 76.3564 336.6309 77.2634 333.5739 77.2634 333.5739 79.3634 336.3589 79.3634 336.3589 80.3044 333.5739 80.3044 333.5739 82.6614 336.6309 82.6614 336.6309 83.5744 332.5449 83.5744"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "339.543 76.3564 340.955 76.3564 344.129 82.1724 344.143 82.1724 344.143 76.3564 345.219 76.3564 345.219 83.5744 343.855 83.5744 340.602 77.6194 340.584 77.6194 340.584 83.5744 339.543 83.5744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.0605,77.5312 C352.6055,77.2742 352.0955,77.1242 351.5805,77.1242 C349.9195,77.1242 348.8125,78.3402 348.8125,79.9532 C348.8125,81.6612 350.0295,82.7852 351.5255,82.7852 C352.0355,82.7852 352.7285,82.6482 353.0855,82.4382 L353.1505,83.4442 C352.6055,83.6662 351.9335,83.6972 351.5115,83.6972 C349.2405,83.6972 347.7345,82.2382 347.7345,79.9232 C347.7345,77.7132 349.3265,76.2362 351.5255,76.2362 C352.0745,76.2362 352.6235,76.3142 353.1385,76.5372 L353.0605,77.5312 Z",
    id: "Fill-32",
    fill: "#0C318F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#0C318F",
    mask: "url(#mask-4)",
    points: "357.4805 80.5634 354.6155 76.3564 355.8715 76.3564 358.0175 79.5724 360.0975 76.3564 361.3145 76.3564 358.5005 80.5634 358.5005 83.5744 357.4805 83.5744"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.25ee75a9f9bbe842031cd1c95871a854.svg";
export { ForwardRef as ReactComponent };